// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch } from 'react-router-dom';

import { AmplifyAuthenticator, AmplifyButton, AmplifySection } from '@aws-amplify/ui-react';
import { Auth } from 'aws-amplify';

import { LOGIN_PATH, LOGOUT_PATH, REDIRECT_URL_PARAM } from './constants';

function signInWithFederate(event) {
  event.preventDefault();
  Auth.federatedSignIn({ customProvider: 'FederateOIDC' });
}

const UnauthRoutes = ({ location }) => (
  <Switch>
    <Route path={LOGIN_PATH}>
      <AmplifyAuthenticator>
        <AmplifySection slot="sign-in" role="application">
          <div className="form-section-header">
            <h3 className="header">Welcome to Pundit!</h3>
          </div>
          <AmplifyButton handleButtonClick={(event) => signInWithFederate(event)}>
            <p>Login with midway</p>
          </AmplifyButton>
        </AmplifySection>
      </AmplifyAuthenticator>
    </Route>
    <Route path={LOGOUT_PATH}>
      <Redirect to={LOGIN_PATH} />
    </Route>
    <Route>
      <Redirect
        to={{
          pathname: LOGIN_PATH,
          search: `?${REDIRECT_URL_PARAM}=${location.pathname}${location.search}`,
        }}
      />
    </Route>
  </Switch>
);

UnauthRoutes.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }).isRequired,
};

export default UnauthRoutes;
